import React, { createContext, useState } from 'react'

export const ReligionTaxContext = createContext()

export const ReligionTaxContextProvider = ({children})=> {
    const [ religionItems, setReligionItems ] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);

    return (
        <ReligionTaxContext.Provider value={{ religionItems, setReligionItems, totalAmount, setTotalAmount }}>
            {children}
        </ReligionTaxContext.Provider>
    )
}
